import { Component } from "react";

class Socials extends Component {
    render(){
        return <div>HERERE SOCIALSSS!!!!</div>
    }
}

export default Socials;